goog.provide('el8.apphome.scheduler.dialog.confirmRecurringEvent');

goog.require('el8.uiwidget.QuickSelectDialog');


el8.apphome.scheduler.dialog.confirmRecurringEvent = (function() {

    var _callbackFn = null;

    var that = new el8.uiwidget.QuickSelectDialog({
        title: '',
        msg: 'Apply this change:',
        list: [
            'Only to this event (it will no longer be part of the repeating series)',
            'To this event and all following in the series'
        ],
        callbackFn: function(index) {
            var applyAll = (index*1 === 1);
            if (_callbackFn) { _callbackFn(applyAll); }
            that.hide();
        }
    });

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        super_show.call(that);
        that.setTitle(spec.title || '');
        _callbackFn = spec.callbackFn || null;
    };

    return that;

})();

